import React from 'react';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaYoutube } from 'react-icons/fa';
import logo from "../assets/images/logo.jpg";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { name: 'About Us', href: '#about' },
      { name: 'Our Team', href: '#about' },
      { name: 'Vision & Mission', href: '#about' },
      { name: 'Why Choose RENGIE', href: '#why-us' }
    ],
    services: [
      { name: 'Residential Solar', href: '#residential' },
      { name: 'Commercial Solar', href: '#commercial' },
      { name: 'Society Solar', href: '#society' },
      { name: 'Solar Water Heater', href: '#water-heater' }
    ],
    resources: [
      { name: 'PM Suryaghar Yojana', href: '#pm-suryaghar' },
      { name: 'How It Works', href: '#how-it-works' },
      { name: 'Service Areas', href: '#contact' },
      { name: 'Contact Us', href: '#contact' }
    ]
  };

  const credentials = [
    'Empanelled with SBPDCL',
    'Empanelled with NBPDCL',
    'Empanelled with JBVNL',
    'DPIIT Recognized Startup'
  ];

  return (
    <footer className="footer bg-dark text-white pt-5 pb-3">
      <div className="container">
        {/* Main Footer Content */}
        <div className="row g-4 mb-4">
          {/* Company Info */}
          <div className="col-lg-4">
            <div className="mb-4">
              <img
                src={logo}
                alt="RENGIE Logo"
                height="50"
                className="mb-3"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
              <h5 className="fw-bold mb-3" style={{ color: '#00D084' }}>
                RENGIE SOLUTION PVT. LTD.
              </h5>
            </div>
            <p className="text-white-50 mb-4">
              Engineering a cleaner and more sustainable future by making renewable energy 
              accessible across Bihar & Jharkhand. Solar systems must be engineered, not sold.
            </p>
            
            {/* Credentials Badges */}
            <div className="mb-4">
              {credentials.map((cred, index) => (
                <span
                  key={index}
                  className="badge bg-success bg-opacity-25 text-success me-2 mb-2 px-3 py-2"
                >
                  <i className="bi bi-patch-check-fill me-1"></i>
                  {cred}
                </span>
              ))}
            </div>

            {/* Social Links */}
            <div className="social-links">
              <h6 className="fw-semibold mb-3">Follow Us</h6>
              <div className="d-flex gap-3">
                <a href="#" className="text-white-50 fs-4" aria-label="Facebook">
                  <FaFacebook />
                </a>
                <a href="#" className="text-white-50 fs-4" aria-label="Twitter">
                  <FaTwitter />
                </a>
                <a href="#" className="text-white-50 fs-4" aria-label="LinkedIn">
                  <FaLinkedin />
                </a>
                <a href="#" className="text-white-50 fs-4" aria-label="Instagram">
                  <FaInstagram />
                </a>
                <a href="#" className="text-white-50 fs-4" aria-label="YouTube">
                  <FaYoutube />
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links - Company */}
          <div className="col-lg-2 col-md-4">
            <h5 className="fw-bold mb-4" style={{ color: '#00D084' }}>Company</h5>
            <ul className="list-unstyled">
              {footerLinks.company.map((link, index) => (
                <li key={index} className="mb-2">
                  <a href={link.href} className="text-white-50 text-decoration-none">
                    <i className="bi bi-chevron-right me-2"></i>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links - Services */}
          <div className="col-lg-2 col-md-4">
            <h5 className="fw-bold mb-4" style={{ color: '#00D084' }}>Services</h5>
            <ul className="list-unstyled">
              {footerLinks.services.map((link, index) => (
                <li key={index} className="mb-2">
                  <a href={link.href} className="text-white-50 text-decoration-none">
                    <i className="bi bi-chevron-right me-2"></i>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links - Resources */}
          <div className="col-lg-2 col-md-4">
            <h5 className="fw-bold mb-4" style={{ color: '#00D084' }}>Resources</h5>
            <ul className="list-unstyled">
              {footerLinks.resources.map((link, index) => (
                <li key={index} className="mb-2">
                  <a href={link.href} className="text-white-50 text-decoration-none">
                    <i className="bi bi-chevron-right me-2"></i>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-lg-2">
            <h5 className="fw-bold mb-4" style={{ color: '#00D084' }}>Contact</h5>
            <ul className="list-unstyled contact-info">
              <li className="mb-3">
                <i className="bi bi-geo-alt-fill text-success me-2"></i>
                <small className="text-white-50">
                  Road No. 15E, Rajeev Nagar, Patna - 800024
                </small>
              </li>
              <li className="mb-3">
                <i className="bi bi-telephone-fill text-success me-2"></i>
                <small className="text-white-50">
                  +91-9031654981<br />
                  +91-9031654984
                </small>
              </li>
              <li className="mb-3">
                <i className="bi bi-envelope-fill text-success me-2"></i>
                <small className="text-white-50">
                  askus@rengie.in
                </small>
              </li>
              <li>
                <i className="bi bi-globe text-success me-2"></i>
                <small className="text-white-50">
                  www.rengie.in
                </small>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <hr className="border-secondary opacity-25 my-4" />

        {/* Bottom Footer */}
        <div className="row align-items-center">
          <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
            <p className="mb-0 text-white-50 small">
              © {currentYear} RENGIE Solution Pvt. Ltd. All Rights Reserved.
            </p>
          </div>
          <div className="col-md-6 text-center text-md-end">
            <a href="#" className="text-white-50 text-decoration-none small me-3">
              Privacy Policy
            </a>
            <a href="#" className="text-white-50 text-decoration-none small me-3">
              Terms & Conditions
            </a>
            <a href="#" className="text-white-50 text-decoration-none small">
              Sitemap
            </a>
          </div>
        </div>

        {/* Tech Credit */}
        <div className="row mt-3">
          <div className="col-12 text-center">
            <p className="mb-0 text-white-50" style={{ fontSize: '0.75rem' }}>
              <i className="bi bi-code-slash me-1"></i>
              Designed & Developed with <span style={{ color: '#00D084' }}>♥</span> for a Sustainable Future
            </p>
          </div>
        </div>
      </div>

      {/* Custom Footer Styles */}
      <style jsx>{`
        .footer {
          background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
        }
        
        .footer a:hover {
          color: #00D084 !important;
          padding-left: 5px;
          transition: all 0.3s ease;
        }
        
        .social-links a:hover {
          transform: translateY(-3px);
          color: #00D084 !important;
          transition: all 0.3s ease;
        }
      `}</style>
    </footer>
  );
};

export default Footer;
